import { Settings } from '../../app/settings';
// import * as Sentry from '@sentry/react';

const emitLogMessage = (
  messageType: 'debug' | 'info' | 'warn' | 'error',
  message: string,
  ...supportingDetails: unknown[]
): void => {
  // eslint-disable-next-line no-console
  console[messageType](message, ...supportingDetails);
};

const debug = (primaryMessage: string, ...supportingData: unknown[]): void => {
  if (Settings.enableDebug) {
    emitLogMessage('debug', `${Math.floor(performance.now())} - ${primaryMessage}`, ...supportingData);
  }
};
const warn = (primaryMessage: string, ...supportingData: unknown[]): void => {
  emitLogMessage('warn', primaryMessage, ...supportingData);
};
const error = (primaryMessage: string, ...supportingData: unknown[]): void => {
  //    Sentry.captureException(e);

  emitLogMessage('error', primaryMessage, ...supportingData);
};
const info = (primaryMessage: string, ...supportingData: unknown[]): void => {
  emitLogMessage('info', primaryMessage, ...supportingData);
};

export const logger = {
  debug,
  warn,
  error,
  info,
};
